import { render } from "./Sidebar.vue?vue&type=template&id=688dbdc5&scoped=true&lang=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=688dbdc5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-688dbdc5"

export default script